import React, { useEffect, useRef, useState } from 'react'
import { CheckIcon, CopyIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useCopyToClipboard } from 'usehooks-ts'

import { Button } from '@/shared/components/ui/button'

export default function MetaValue({
	label,
	value,
}: {
	label: string
	value?: string | number
}) {
	const { t } = useTranslation()

	const rendered = useRef(false)
	const [, copy] = useCopyToClipboard()
	const [isCopied, setIsCopied] = useState(false)
	useEffect(() => {
		rendered.current = true

		return () => {
			rendered.current = false
		}
	}, [])

	return (
		<div className='flex items-center gap-1 text-sm'>
			<span className='text-sm leading-none font-medium tracking-tight text-muted-foreground'>
				{label}:
			</span>
			<span className='font-bold'>{value}</span>
			<Button
				variant='ghost'
				size='icon-xs'
				onClick={async () => {
					const result = await copy(value as string)
					if (result) {
						toast.success(
							t('app.succesfull_copied', {
								defaultValue: 'Successfull copied to clipboard',
							}),
							{
								closeButton: false,
								id: 'copy',
							}
						)
						setIsCopied(true)
						setTimeout(() => {
							if (rendered.current) {
								setIsCopied(false)
							}
						}, 4000)
					}
				}}
			>
				{isCopied ? <CheckIcon className='text-success' /> : <CopyIcon />}
			</Button>
		</div>
	)
}
